import React, { useEffect, useState } from 'react';
import { SearchColumnSelectorPanel } from 'components/sidePanel/searchAndFilter';
import { ITabItem, UnifiedLargeTabSelector, useTabs } from 'components/tab';
import FiltersButtonsContainer from 'components/sidePanel/searchAndFilter/filter/FiltersButtonsContainer';
import TablePanel from 'components/sidePanel/searchAndFilter/table/tablePanel';
import InfoPanel from 'components/sidePanel/searchAndFilter/info/infoPanel';
import ImageToolsPanel from 'components/sidePanel/searchAndFilter/imageTools/imageToolsPanel';
import ScoresPanel from 'components/sidePanel/searchAndFilter/score/scoresPanel';

export const useSidePanelContent = () => {
  const [selectedDisplayIndex, setSelectedDisplayIndex] = useState(null);
  const pathItems = location.pathname.split('/');

  const onTabSelectionChange = (value) => {
    setSelectedDisplayIndex(value);
  };

  const tabItemsDict: Record<string, ITabItem> = {
    Custom: {
      customTabSelectionItem: (
        <UnifiedLargeTabSelector iconName="CustomTable" title="Columns" />
      ),
      content: <SearchColumnSelectorPanel />,
      externalKey: 'custom',
    },
    Filter: {
      customTabSelectionItem: (
        <UnifiedLargeTabSelector iconName="Funnel" title="Filter" />
      ),
      content: <FiltersButtonsContainer />,
      externalKey: 'filter',
    },
    Info: {
      customTabSelectionItem: <UnifiedLargeTabSelector iconName="Info" title="Info" />,
      content: <InfoPanel />,
      externalKey: 'info',
    },
    Table: {
      customTabSelectionItem: <UnifiedLargeTabSelector iconName="Table" title="Table" />,
      content: <TablePanel />,
      externalKey: 'table',
    },
    Tools: {
      customTabSelectionItem: (
        <UnifiedLargeTabSelector iconName="SnFTools" title="Tools" />
      ),
      content: <ImageToolsPanel />,
      externalKey: 'tools',
    },
    Score: {
      customTabSelectionItem: (
        <UnifiedLargeTabSelector iconName="PanelScore" title="Score" />
      ),
      content: <ScoresPanel />,
      externalKey: 'score',
    },
  };

  const tabsConsolidatedListByUrl = {
    '': {
      tabItemsList: [tabItemsDict['Custom']],
      tab: 'custom',
    },
    result: {
      tabItemsList: [
        tabItemsDict['Custom'],
        tabItemsDict['Filter'],
        tabItemsDict['Info'],
      ],
      tab: 'filter',
    },
    canvas: {
      tabItemsList: [
        tabItemsDict['Custom'],
        tabItemsDict['Filter'],
        tabItemsDict['Info'],
        tabItemsDict['Table'],
        tabItemsDict['Score'],
      ],
      tab: 'table',
    },
    compare: {
      tabItemsList: [
        tabItemsDict['Custom'],
        tabItemsDict['Filter'],
        tabItemsDict['Info'],
        tabItemsDict['Table'],
        tabItemsDict['Tools'],
        tabItemsDict['Score'],
      ],
      tab: 'table',
    },
    analytics: {
      tabItemsList: [tabItemsDict['Filter'], tabItemsDict['Info']],
      tab: 'filter',
    },
    drop: {
      tabItemsList: [
        tabItemsDict['Custom'],
        tabItemsDict['Filter'],
        tabItemsDict['Info'],
        tabItemsDict['Table'],
        tabItemsDict['Tools'],
        tabItemsDict['Score'],
      ],
      tab: 'table',
    },
  };

  let tab = '';
  let tabItems: ITabItem[] = [];

  // Ensure there are at least three parameters
  if (pathItems.length >= 4) {
    tab = pathItems[pathItems.length - 1];
  }

  useEffect(() => {
    setSelectedDisplayIndex(tabsConsolidatedListByUrl[tab].tab);
  }, [location.pathname]);

  tabItems = tabsConsolidatedListByUrl[tab].tabItemsList;

  return useTabs(tabItems, selectedDisplayIndex, onTabSelectionChange, false, true);
};
